import { useQuery } from 'react-query';

// app
import { adminAxios } from '../../admin.api';
import { OPERATIONAL_CLIENTS } from '../../queryKeys';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';
import config from 'config';

export const useGetOperationalClients = (params = {}) => {
  const { name, page, size, firstLetterFilter } = params;
  const endpointParams = {
    ...(firstLetterFilter && firstLetterFilter !== '' && { firstLetterFilter: firstLetterFilter }),
    page: page || 0,
    size: size || config.ui.gridPagination.default,
    orderBy: 'name',
    direction: 'asc',
    ...(name && { name }),
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.queries.useGetOperationalClients',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  return useQuery(
    [OPERATIONAL_CLIENTS, endpointParams],
    async () => {
      const result = await adminAxios.get('client/operational', { params: endpointParams });

      return result?.data;
    },
    {
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
